var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"navigation-top__lang"},[_c('RouterLink',{attrs:{"to":{ name: 'home', params: { lang: _vm.lang } }}},[_vm._v(_vm._s(_vm.lang.toUpperCase()))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }